import React from 'react';

const SpinnerLoad = ({ size = 'default' }) => {
  const sizeClasses = {
    small: 'h-4 w-4 border-2',
    default: 'h-8 w-8 border-4'
  };
  
  return (
    <div className="flex justify-center items-center">
      <div className={`animate-spin rounded-full ${sizeClasses[size]} border-gray-300 border-t-blue-600`}></div>
    </div>
  );
};

export default SpinnerLoad;
